import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["items", "item", "template", "destroy"]

  add() {
    const html = this.templateTarget.innerHTML.replaceAll("NEW_RECORD", Date.now().toString())
    this.itemsTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    const item = event.currentTarget.closest("[data-sale-form-target='item']")
    const destroy = item.querySelector("[data-sale-form-target='destroy']")
    if (item.querySelector("input[name*='[id]']")) {
      destroy.value = "1"
      item.hidden = true
    } else {
      item.remove()
    }
  }
}
